import { render, staticRenderFns } from "./SaleInventories.vue?vue&type=template&id=fa574ac0&lang=pug"
import script from "./SaleInventories.vue?vue&type=script&lang=js"
export * from "./SaleInventories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports